import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-zen-ai-input',
  templateUrl: './zen-ai-input.component.html',
  styleUrls: ['./zen-ai-input.component.scss'],
})
export class ZenAiInputComponent {
  @Input() queryControl!: FormControl;
  @Input() isLoading = false;
  @Input() placeholder = 'Ask me anything about this violation';
  @Output() send = new EventEmitter<void>();
  @Output() keyPress = new EventEmitter<KeyboardEvent>();

  public onSendClick(): void {
    this.send.emit();
  }

  public onKeyPress(event: KeyboardEvent): void {
    this.keyPress.emit(event);
  }
}
